export default function(api: GlobalFetch) {
  return async function(id) {
    const response = await api.fetch(
      `/api/v2/booking/activate/id_integration/${id}`,
      {
        method: 'POST',
      },
    )

    return await handleResponse(response)
  }
}

const handleResponse = async (response: Response) => {
  const { status } = response

  if (status === 200) {
    return await response.json()
  }

  throw new Error('Error')
}
